<template>
    <div>
        <quill-editor
            :content="value"
            @change="onEditorChange"
            :options="options">
        </quill-editor>

    </div>
</template>
<style>
</style>
<script>
    import vue from 'vue'
    import VueQuillEditor from 'vue-quill-editor'
    vue.use(VueQuillEditor);
    export default{
        props: {
            placeholder: {
                default(){
                    return null
                }
            },
            value: {
                default: function () {
                    return "";
                }
            },
            options: {
                default(){
                    return {
                        placeholder: this.placeholder,
                        modules: {
                            toolbar: [
                                [{'size': ['small', false, 'large']}],
                                ['bold', 'italic'],
                                [{'list': 'ordered'}, {'list': 'bullet'}],
                                ['image'],
                                [{'color': []}, {'background': []}],
                                ['blockquote', 'code-block'],
                                [{'header': 1}, {'header': 2}],
                                [{'script': 'sub'}, {'script': 'super'}],
                                [{'indent': '-1'}, {'indent': '+1'}],
                                [{'color': []}, {'background': []}],
                                [{'align': []}],
                            ]
                        }
                    }
                }
            }
        },
        name: 'c-richtext',
        data(){
            return {
                myoptions: {}
            }
        },
        watch: {
            value(val){
                this.$emit('input', val);
            }
        },
        methods: {
            onEditorChange(val){
                this.$emit('input', val.html);
            }
        },
        mounted() {
            $(".ql-container.ql-snow").attr('style', 'min-height:120px');
            this.myoptions = this.options;
        },
        components: {}
    }
</script>



// WEBPACK FOOTER //
// richtext.vue?7f867be8